import { render, staticRenderFns } from "./signingRules.vue?vue&type=template&id=bc475780&scoped=true&"
import script from "./signingRules.vue?vue&type=script&lang=js&"
export * from "./signingRules.vue?vue&type=script&lang=js&"
import style0 from "./signingRules.vue?vue&type=style&index=0&id=bc475780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc475780",
  null
  
)

export default component.exports